import FormOptionCard, {
  FormOptionCardConfig,
} from "app/components/FormOptionCard";
import React from "react";
import { useDispatch } from "react-redux";

import {
  locksKey,
  locksLabels,
  useQuoteAccessories,
} from "../../../hooks/useQuoteAccessories";
import { quotesActions } from "../../../redux/slice";
import { QuoteLocksCard } from "../../../types";
import { CardRow, StructureSection } from "./BoxStructureFields";

const noteField = (titleKey: string): FormOptionCardConfig => ({
  titleKey,
  fields: ["note"],
  notePlaceholderKey: locksKey("FIELDS.NOTE"),
});

const locksCards: Record<QuoteLocksCard, FormOptionCardConfig> = {
  dieselLock: noteField(locksKey("CARDS.DIESEL_LOCK")),
  ureaLock: noteField(locksKey("CARDS.UREA_LOCK")),
  batteriesLock: noteField(locksKey("CARDS.BATTERIES_LOCK")),
  hydraulicTailLiftMotorLock: noteField(
    locksKey("CARDS.HYDRAULIC_TAIL_LIFT_MOTOR_LOCK")
  ),
  hydraulicTailLiftLock: {
    titleKey: locksKey("CARDS.HYDRAULIC_TAIL_LIFT_LOCK"),
    fields: ["radio"],
    radioLabelKey: locksKey("FIELDS.TYPE"),
    radioOptions: [
      { value: "HASP", labelKey: locksKey("OPTIONS.HASP") },
      { value: "EYELET", labelKey: locksKey("OPTIONS.EYELET") },
    ],
  },
  spareWheelLock: noteField(locksKey("CARDS.SPARE_WHEEL_LOCK")),
};

const AccessoriesLocks = () => {
  const dispatch = useDispatch();
  const data = useQuoteAccessories();

  const renderCard = (cardId: QuoteLocksCard) => (
    <FormOptionCard
      key={cardId}
      config={locksCards[cardId]}
      value={data.locks[cardId]}
      labels={locksLabels}
      onChange={(value) =>
        dispatch(
          quotesActions.updateAccessories({
            section: "locks",
            key: cardId,
            value,
          })
        )
      }
    />
  );

  return (
    <StructureSection titleKey={locksKey("SECTIONS.LOCKS")}>
      <CardRow columns={4}>
        {renderCard("dieselLock")}
        {renderCard("ureaLock")}
        {renderCard("batteriesLock")}
        {renderCard("hydraulicTailLiftMotorLock")}
      </CardRow>
      <CardRow>
        {renderCard("hydraulicTailLiftLock")}
        {renderCard("spareWheelLock")}
      </CardRow>
    </StructureSection>
  );
};

export default AccessoriesLocks;
